/* eslint-disable import/prefer-default-export */
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { InsightViewOption } from 'enums'
import { AlertDayOfWeekStrings } from 'enums/AlertDayOfWeek'
import { getTimeZoneId, TimeZoneInfo, TimeZoneStrings } from 'enums/TimeZone'

dayjs.extend(duration)
dayjs.extend(utc)
dayjs.extend(timezone)

export const getHourLabel = (hour: number) => dayjs().set('hour', hour).format('ha')

export const getDataLabel = (name: string, viewOption: string) => {
  switch (viewOption) {
    case InsightViewOption.HOUR_OF_DAY: {
      const hour = Number(name.split('.')[1])
      return getHourLabel(hour)
    }
    case InsightViewOption.DAY_OF_WEEK: {
      const weekDay = name.split('.')[0]
      return weekDay
    }
    case InsightViewOption.HOUR_OF_WEEK: {
      const hour = Number(name.split('.')[1])
      const weekDay = name.split('.')[0]
      return `${weekDay} ${getHourLabel(hour)}`
    }
    default:
      return name
  }
}

export const timeRangeWeekAdjust = ({
  start,
  end,
  isCustom
}: {
  start: number
  end: number
  isCustom: boolean
}) => {
  const WEEK = dayjs.duration(1, 'week').asMilliseconds()
  const range = end - start

  if (range > WEEK && range % WEEK > 0) {
    const newEnd = isCustom ? dayjs(end).valueOf() : dayjs(end).subtract(1, 'hour').valueOf()
    const weekNum = Math.floor(dayjs.duration(newEnd - start).asWeeks())
    const newStart = newEnd - WEEK * weekNum

    return {
      start: newStart,
      end: newEnd,
      isDirty: newStart !== start || newEnd !== end
    }
  }

  return {
    start,
    end,
    isDirty: false
  }
}

export const getDisplayTimeZone = (timeZoneKey?: TimeZoneStrings) => {
  const tzId = timeZoneKey ? getTimeZoneId(timeZoneKey) : getTimeZoneId()

  const cityName = timeZoneKey
    ? TimeZoneInfo[timeZoneKey][1]
    : Object.values(TimeZoneInfo).find((tzInfo) => tzInfo[0] === tzId)?.[1]

  const utcOffset = dayjs().tz(tzId).format('Z')

  return `(GMT${utcOffset} ${cityName})`
}

export const getWeekDayToNumber = (weekDay: AlertDayOfWeekStrings) => {
  const weekDayToNumber: Record<AlertDayOfWeekStrings, number> = {
    Monday: 6,
    Tuesday: 5,
    Wednesday: 4,
    Thursday: 3,
    Friday: 2,
    Saturday: 1,
    Sunday: 0
  }
  return weekDayToNumber[weekDay]
}

export const weekDayAbbreviation: Record<AlertDayOfWeekStrings, string> = {
  Monday: 'Mon',
  Tuesday: 'Tue',
  Wednesday: 'Wed',
  Thursday: 'Thu',
  Friday: 'Fri',
  Saturday: 'Sat',
  Sunday: 'Sun'
}

export const getWeekDayAbbreviation = (weekDay: AlertDayOfWeekStrings) =>
  weekDayAbbreviation[weekDay]
